import {
  Box,
  Button,
  Container,
  Stack,
  Typography,
  useTheme,
} from "@mui/material";
import CustomDialog from "global/components/CustomDialog/CustomDialog";

interface CustomProps {
  title: string;
  imageTemplate: string;
  description?: string;
  isVisible: boolean;
  btn1Title?: string;
  //   btn2Title?: string;
  btn1Variant?: "text" | "outlined" | "contained";
  //   btn2Variant?: "text" | "outlined" | "contained";
  btn1OnClick: Function;
  //   btn2OnClick: Function;
  isNavsHide?: boolean;
  handleDialogClose: Function;
}

const PreviewTemplateModal = (props: CustomProps) => {
  const theme = useTheme();
  const getDialogHeader = () => {
    return (
      <>
        <Box display="flex" justifyContent="center" pt={3}>
          <Typography variant="h4" color={theme.palette.primary.main}>
            {props.title}
          </Typography>
        </Box>
      </>
    );
  };

  const getBody = () => {
    return (
      <>
        <Box display="flex" flexDirection="column" justifyContent="center">
          <Container
            maxWidth="md"
            sx={{
              display: "flex",
              px: 0,
              mt: 0,
            }}
          >
            <Box>
              <Box mt={2} mb={2}>
                {props.imageTemplate && (
                  <Box
                    sx={{
                      width: "100%",
                      "&::-webkit-scrollbar": {
                        display: "none",
                      },
                    }}
                  >
                    <img
                      src={props.imageTemplate}
                      height={"100%"}
                      width={"100%"}
                    />
                  </Box>
                )}
              </Box>
            </Box>
          </Container>
        </Box>
      </>
    );
  };
  const getFooter = () => {
    return (
      <Stack direction="row" spacing={2} mb={1}>
        <Button
          id="contacts_add__cancel_btn"
          variant={props.btn1Variant ? props.btn1Variant : "outlined"}
          sx={{
            width: "7.125rem",
            height: "2.5rem",
          }}
          onClick={() => props.btn1OnClick()}
        >
          {props.btn1Title ? props.btn1Title : "No"}
        </Button>
        {/* <Button
          id="contacts_add_save_btn"
          variant={props.btn2Variant ? props.btn2Variant : "contained"}
          onClick={async () => await props.btn2OnClick()}
          sx={{
            width: "7.125rem",
            height: "2.5rem",
          }}
        >
          {props.btn2Title ? props.btn2Title : "Yes"}
        </Button> */}
      </Stack>
    );
  };

  return (
    <CustomDialog
      handleDialogClose={props.handleDialogClose}
      isDialogOpen={props.isVisible}
      title={getDialogHeader()}
      body={getBody()}
      footer={getFooter()}
      closeButtonVisibility={true}
      closable
      isNavsHide={props.isNavsHide ?? false}
      maxWidth="sm"
    />
  );
};

export default PreviewTemplateModal;
